import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import './utils/index.mjs';
import { ProgramCache } from '@pixi/utils';
import defaultFragment from './defaultProgram.mjs';
import defaultVertex from './defaultProgram2.mjs';
import { settings } from '@pixi/settings';
import { PRECISION } from '@pixi/constants';
import { setPrecision } from './utils/setPrecision.mjs';
import { getMaxFragmentPrecision } from './utils/getMaxFragmentPrecision.mjs';
var UID = 0;
var nameCache = {};
var Program = /*#__PURE__*/function () {
  function Program(vertexSrc, fragmentSrc) {
    var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "pixi-shader";
    var extra = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    _classCallCheck(this, Program);
    this.extra = {};
    this.id = UID++;
    this.vertexSrc = vertexSrc || Program.defaultVertexSrc;
    this.fragmentSrc = fragmentSrc || Program.defaultFragmentSrc;
    this.vertexSrc = this.vertexSrc.trim();
    this.fragmentSrc = this.fragmentSrc.trim();
    this.extra = extra;
    if (this.vertexSrc.substring(0, 8) !== "#version") {
      name = name.replace(/\s+/g, "-");
      if (nameCache[name]) {
        nameCache[name]++;
        name += "-".concat(nameCache[name]);
      } else {
        nameCache[name] = 1;
      }
      this.vertexSrc = "#define SHADER_NAME ".concat(name, "\n").concat(this.vertexSrc);
      this.fragmentSrc = "#define SHADER_NAME ".concat(name, "\n").concat(this.fragmentSrc);
      this.vertexSrc = setPrecision(this.vertexSrc, settings.PRECISION_VERTEX, PRECISION.HIGH);
      this.fragmentSrc = setPrecision(this.fragmentSrc, settings.PRECISION_FRAGMENT, getMaxFragmentPrecision());
    }
    this.glPrograms = {};
    this.syncUniforms = null;
  }
  _createClass(Program, null, [{
    key: "defaultVertexSrc",
    get: function get() {
      return defaultVertex;
    }
  }, {
    key: "defaultFragmentSrc",
    get: function get() {
      return defaultFragment;
    }
  }, {
    key: "from",
    value: function from(vertexSrc, fragmentSrc, name) {
      var key = vertexSrc + fragmentSrc;
      var program = ProgramCache[key];
      if (!program) {
        ProgramCache[key] = program = new Program(vertexSrc, fragmentSrc, name);
      }
      return program;
    }
  }]);
  return Program;
}();
export { Program };